module.exports = __webpack_public_path__ + "static/img/market_phone_bg.1abbd113.png";